import Spinner from "./Spinner";

const Button = ({
  label,
  handleClick,
  isLoading = false,
  disabled = false,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className="bg-[#000000] w-full text-[16px] font-medium h-[45px] flex items-center justify-center gap-[5px] rounded-[30px] text-white"
    >
      {!isLoading ? label : <Spinner />}
    </button>
  );
};

export default Button;
